export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.99 9.588V.998h2v8.59l2.3-2.29 1.41 1.41-4 4a.996.996 0 01-1.41 0l-4-4 1.41-1.41 2.29 2.29zM17 16c.55 0 1-.45 1-1v-4h2v4c0 1.66-1.34 3-3 3H3c-1.66 0-3-1.34-3-3l.04-3.96h2L2 15c0 .55.45 1 1 1h14z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "20",
    "height": "18",
    "viewBox": "0 0 20 18",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};